import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedList from '../../commons/pagedList'
import { ExpenseStatus } from '../../../domain/expenses/expenseStatus'
import { NamedItem } from '../../../domain/common/namedItem'
import OrderedPageFilter from '../../commons/orderedPageFilter'

export type PerksReimbursementRequestsResponse = {
  id: string
  expenseNumber: number
  serviceProvider: string
  expenseStatus: ExpenseStatus
  purchasedDate: Date
  amount: number
  createdAt: Date
  category: NamedItem
}

export const getPerksReimbursementRequests = (
  planPeriodId: string,
  filter: OrderedPageFilter,
): Promise<PagedList<PerksReimbursementRequestsResponse>> => {
  return adminHttpClient.get(`/EEDashboard/Perks/GetPerksReimbursementRequests/${planPeriodId}`, filter)
}
